import React, { FunctionComponent } from 'react'

import { StyledProgressBar, StyledTimer } from './style'

export const Timer: FunctionComponent = () => {
    return (
        <StyledTimer>
            <StyledProgressBar />
        </StyledTimer>
    )
}
